import { Component, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BaseControl } from '../../ui/controls/base-control.model';
import { NumericControl } from '../../ui/controls/numeric-control.model';
import { SelectControl } from '../../ui/controls/select-control.model';
import { eyeIcon, SVGIcon } from "@progress/kendo-svg-icons";

import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { DialogComponent } from '../../../shared/components/dialog/dialog.component';
import { EditorControl } from '../../ui/controls/editor-control.model';
import { EditorComponent, EditorModule } from "@progress/kendo-angular-editor";
import { GridControl } from '../../ui/controls/grid-control.model';

import { OnChangeArgs, SelectFieldComponent } from '../select-field/select-field.component';
import { UrlFieldComponent } from '../url-field/url-field.component';
import { MoneyFieldComponent } from '../money-field/money-field.component';
import { CheckBoxModule, NumericTextBoxModule, TextAreaModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { CardModule } from '@progress/kendo-angular-layout';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { LabelModule } from '@progress/kendo-angular-label';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { UploadImageComponent } from '../upload-image/upload-image.component';
import { GridKendoCardComponent } from '../grid-kendo-card/grid-kendo-card.component';
import { faAdd } from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { ListBoxControl } from '../../ui/controls/listbox-control.model';
import { ListBoxModule, ListBoxToolbarConfig } from '@progress/kendo-angular-listbox';
import { ListBoxComponent } from '../list-box/list-box.component';


@Component({
    selector: 'app-kendo-card-form-control',
    imports: [
        forwardRef(() => SelectFieldComponent),
        UrlFieldComponent,
        MoneyFieldComponent,
        ListBoxModule,
        TextBoxModule,
        TextAreaModule,
        DatePickerModule,
        ReactiveFormsModule,
        DialogComponent,
        EditorModule,
        UploadImageComponent,
        ListBoxComponent,
        FaIconComponent,
        GridKendoCardComponent,
        KendoCardFormControlComponent,
        CardModule,
        IndicatorsModule,
        NumericTextBoxModule,
        LabelModule,
        TranslateModule,
        CheckBoxModule
    ],
    templateUrl: './kendo-card-form-control.component.html',
    styleUrls: ['./kendo-card-form-control.component.css']
})
export class KendoCardFormControlComponent {

  @Input() control: BaseControl;
  @Input() editorControl: EditorControl;
  @Input() listBoxControl: ListBoxControl;
  @Input() gridControl: GridControl;

  @Input() form: FormGroup;
  @Input() submitted: boolean;

  @ViewChild("upload") public dialog: DialogComponent;
  @ViewChild("textbox") public textbox: TextBoxComponent;

  @Output() @ViewChild("editor") public editor: EditorComponent;
  @Output() @ViewChild("listbox") public listbox: ListBoxComponent;

  public eyeIcon: SVGIcon = eyeIcon;

  constructor() { }

  ngOnInit() {
    this.editorControl = this.control as EditorControl;
    this.gridControl = this.control as GridControl;
    this.listBoxControl = this.control as ListBoxControl;
  }

  toNumeric(control: BaseControl): NumericControl {
    return control as NumericControl;
  }

  onSelectChange(control: BaseControl, args: OnChangeArgs): void {
    var select = control as SelectControl;
    if (select.onchange != undefined) {
      select.onchange(args);
    }
  }

  public open() {
    this.dialog.open();
  }

  //public toggleVisibility(): void {
  //  const inputEl = this.textbox.input.nativeElement;

  //  if (inputEl.type === "password") {
  //    inputEl.type = "text";
  //  } else {
  //    inputEl.type = "password";
  //  }
  //}

}
